import { toast } from "react-toastify";
import { sendRequest } from "../libs/axiosConfig";
import { errMsg } from "../utils/helperFunction";

export const initiateOrderApi = async (reqBody) => {
  try {
    const { paymentPlanId, paymentFrequency, amount, paymentMethod } = reqBody;

    const response = await sendRequest({
      url: `/api/v1/orders`,
      method: "POST",
      body: {
        paymentPlanId,
        paymentFrequency,
        amount,
        paymentMethod,
      },
    });

    return response.data;
  } catch (err) {
    const message = errMsg(err);

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};

export const getUserOrdersApi = async () => {
  const res = await sendRequest({
    url: `/api/v1/orders`,
  });
  return res;
};

export const verifyOrderPayment = async (reqBody) => {
  try {
    const {
      razorpay_payment_id,
      razorpay_order_id,
      razorpay_signature,
      paymentMethod,
    } = reqBody;

    const response = await sendRequest({
      url: `/api/v1/orders/verify`,
      method: "POST",
      body: {
        razorpay_payment_id,
        razorpay_order_id,
        razorpay_signature,
        paymentMethod,
      },
    });

    return response.data;
  } catch (err) {
    const message = errMsg(err);

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};